import React from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Space, Switch } from 'antd';

import './style.scss';

const SwitchComponent = ({
  label,
  isLoading,
  isChecked,
  onChange,
  disabled,
}) => (
  <div className="switch">
    <Space direction="vertical">
      <Switch
        loading={isLoading}
        onChange={onChange}
        checkedChildren={<CheckOutlined />}
        unCheckedChildren={<CloseOutlined />}
        defaultChecked={isChecked}
        checked={isChecked}
        disabled={disabled}
      />
    </Space>
    <span className="switch-label">{label}</span>
  </div>
);
export default SwitchComponent;
